import React, { useState } from "react";
import styled from "styled-components";
import { RightOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import ReusableTable from "../Performance/ReusableTable";
import COLORS from "common/Colors";
import { Button, Col, Modal, Radio, Row } from "antd";

const Styleddiv = styled.div`
  .breadcrumb {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    color: #1f243b;
  }
  .current-appraisal {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
    cursor: pointer;
  }
  .right-icon {
    width: 10px;
    height: 10px;
    margin-bottom: 10px;
  }
  .settings-title {
    font-weight: 500;
    font-size: 20px;
  }
  .appraisal-information {
    font-weight: 500;
    font-size: 20px;
  }
  .cancel-save-changes {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 78%;
    background-color: white;
    margin-left: 301px;
    display: flex;
    justify-content: end;
    gap: 24px;
    padding: 24px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  }
  .cancel-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #1f243b;
    font-weight: 400;
    font-size: 16px;
    color: #1f243b;
  }
  .save-changes-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #c2fae5;
    border: #c2fae5;
    font-weight: 400;
    font-size: 16px;
  }
`;
const ButtonKeySelect = styled.div`
  margin: 10px;
  padding: 5px 20px;
  border: none;
  border-radius: 5px;
  max-height: 50px;
  background: ${COLORS.PRIMARY};
  font-weight: 600;
  color: #000000;
  white-space: nowrap;

  &:hover {
    background: ${COLORS.PRIMARY};
    color: #000000;
  }
  &:focus {
    background: ${COLORS.PRIMARY};
    color: #000000;
  }
`;
const StyledBox = styled.div`
  box-shadow: 0px 3px 6px #00000015;
  border-radius: 5px;

  .gaf-column-header {
    align-content: baseline;
  }
`;

const EditingAppraisal = () => {
  const history = useHistory();
  const [data, setData] = useState({});
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("reopen");
  const showConfirmModal = () => {
    setIsConfirmModal(true);
  };
  const AcceptPerfContractForm = {
    pages: [
      {
        modalView: false,
        colSpan: [24, 24, 24],
        fields: [
          [
            {
              id: 1,
              label: "Name",
              type: "select",
              name: "name",
              Placeholder: "select",
              value: data["name"],
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 2,
              label: "Staff Level",
              type: "select",
              name: "staffLevel",
              Placeholder: "select",
              value: data["staffLevel"],
              maxLength: 35,
              validationRules: [],
            },
          ],
          [
            {
              id: 3,
              label: "Firm",
              type: "select",
              name: "firm",
              Placeholder: "select",
              value: data["firm"],
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 4,
              label: "Organisational Level",
              type: "select",
              name: "organisationallevel",
              Placeholder: "select",
              value: data["organisationallevel"],
              maxLength: 35,
              validationRules: [],
            },
          ],
          [
            {
              id: 5,
              label: "Year",
              type: "select",
              name: "year",
              Placeholder: "select",
              value: data["year"],
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 6,
              label: "Competency/Quality Circle",
              type: "select",
              name: "competency/Qualitycircle",
              Placeholder: "select",
              value: data["competency/Qualitycircle"],
              maxLength: 35,
              validationRules: [],
            },
          ],
          [
            {
              id: 7,
              label: "Period",
              type: "select",
              name: "period",
              Placeholder: "select",
              value: data["period"],
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 8,
              label: "Additional",
              type: "select",
              name: "additional",
              Placeholder: "select",
              value: data["additional"],
              maxLength: 35,
              validationRules: [],
            },
          ],
          [
            {
              id: 9,
              label: "Department",
              type: "select",
              name: "department",
              Placeholder: "select",
              value: data["department"],
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 10,
              label: "Service Line Expertise",
              type: "text",
              name: "serviceLineExpertise",
              Placeholder: "Enter",
              value: data["serviceLineExpertise"],
              maxLength: 35,
              validationRules: [],
            },
          ],
          [
            {
              id: 11,
              label: "Industry Expertise",
              type: "text",
              name: "industryExpertise",
              Placeholder: "Enter",
              value: data["industryExpertise"],
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 12,
              label: "Grade",
              type: "select",
              name: "grade",
              Placeholder: "select",
              value: data["grade"],
              maxLength: 35,
              validationRules: [],
            },
          ],
          [
            {
              id: 13,
              label: "Hired Date",
              type: "date",
              name: "hiredDate",
              Placeholder: "Select",
              value: data["hiredDate"],
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 14,
              label: "Years with Firm",
              type: "text",
              name: "yearswithFirm",
              Placeholder: "Enter",
              value: data["yearswithFirm"],
              maxLength: 35,
              validationRules: [],
            },
          ],
          [
            {
              id: 15,
              label: "Graduation Status",
              type: "text",
              name: "graduationStatus",
              Placeholder: "Enter",
              value: data["graduationStatus"],
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 16,
              label: "Professional Certification",
              type: "select",
              name: "professionalCertification",
              Placeholder: "Select",
              value: data["professionalCertification"],
              maxLength: 35,
              validationRules: [],
            },
          ],
          [
            {
              id: 17,
              label: "L&D Completed",
              type: "text",
              name: "l&dcompleted",
              Placeholder: "Enter",
              value: data["l&dcompleted"],
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 18,
              label: "Technical Skills Expertise",
              type: "text",
              name: "technicalSkillsExpertise",
              Placeholder: "Enter",
              value: data["technicalSkillsExpertise"],
              maxLength: 35,
              validationRules: [],
            },
          ],
          [
            {
              id: 19,
              label: "Last Promotion Date",
              type: "date",
              name: "lastPromotionDate",
              Placeholder: "Select",
              value: data["lastPromotionDate"],
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 20,
              label: "Last Salary Increase Date",
              type: "date",
              name: "lastSalaryIncreaseDate",
              Placeholder: "Select",
              value: data["lastSalaryIncreaseDate"],
              maxLength: 35,
              validationRules: [],
            },
          ],
          [
            {
              id: 21,
              label: "Target Chargeability %",
              type: "text",
              name: "targetChargeability",
              Placeholder: "Enter",
              value: data["targetChargeability"],
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 22,
              label: "Chargeout Rate",
              type: "text",
              name: "chargeoutRate",
              Placeholder: "Enter",
              value: data["chargeoutRate"],
              maxLength: 35,
              validationRules: [],
            },
          ],
        ],
      },
    ],
  };
  const AppraisalFormData = {
    pages: [
      {
        modalView: false,
        colSpan: [24, 24, 24],
        fields: [
          [
            {
              id: 1,
              label: "Appraisal Name",
              type: "text",
              name: "name",
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 2,
              label: "Type",
              type: "select",
              name: "type",
              maxLength: 35,
              validationRules: [],
            },
          ],
          [
            {
              id: 3,
              label: "From Date",
              type: "date",
              name: "name",
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 4,
              label: "To Date",
              type: "date",
              name: "type",
              maxLength: 35,
              validationRules: [],
            },
          ],
          [
            {
              id: 5,
              label: "Location",
              type: "select",
              name: "name",
              maxLength: 35,
              validationRules: [],
            },
            {
              id: 6,
              label: "No. of Appraisees",
              type: "text",
              name: "type",
              maxLength: 35,
              validationRules: [],
            },
          ],
        ],
      },
    ],
  };
  const AcceptPerformData = [
    {
      category: "Technical",
      percent: "0",
    },
    {
      category: "Individual",
      percent: "0",
    },
    {
      category: "TOTAL",
      percent: "0",
    },
  ];
  const AcceptPerformDatacolumns = [
    {
      title: "CATEGORY",
      dataIndex: "category",
      key: "category",
      width: "70%",
    },
    {
      title: "%",
      dataIndex: "percent",
      key: "percent",
      width: "30%",
      className: "normal-column",
    },
  ];
  const tempdata2 = [
    {
      category: "On The Job",
      percent: "0",
    },
    {
      category: "Off the job",
      percent: "0",
    },
    {
      category: "TOTAL",
      percent: "0",
    },
  ];
  const BasicForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [24, 24, 24],
        fields: [
          [
            {
              id: 1,
              label: "Reviewer:",
              type: "text",
              name: "reviewer",
              Placeholder: "Enter",
            },
            {
              id: 2,
              label: "Chargeout Rate:",
              type: "text",
              name: "chargeoutrate",
              Placeholder: "Enter",
            },
          ],
        ],
      },
    ],
  };
  const tempdata3 = [
    {
      Description: (
        <div>
          <h6>Value & Efficiency:</h6>
          Knowledgeable and well prepared to handle the allocated work. The
          methodology and software used was appropriate. Conclusions reached
          were useful, realistic and adequately supported by relevant facts and
          thorough analysis.
        </div>
      ),
      weight: "0",
    },
    {
      Description: (
        <div>
          <h6>Timely Delivery:</h6>
          The assignment / tasks / sections were completed on a timely basis.
          The timeliness of response to phone calls/e-mails showed care and good
          communication skills. No undue disruption to workplace during the
          assignment.
        </div>
      ),

      weight: "0",
    },
    {
      Description: (
        <div>
          <h6>Quality, Compliance & Risk:</h6>
          Quality and Risks were properly managed and with compliance to
          methodology, tools and processes was as per expectation. Also,
          safeguarding of documents and work environment and staff commitments
          were respected.
        </div>
      ),

      weight: "0",
    },
    {
      Description: (
        <div>
          <h6>Client satisfaction:</h6>
          Demonstrated professionalism and the handling of client, staff and
          supervision of the job was impeccable. Both internal and external
          stakeholders were satisfied with the delivery.
        </div>
      ),
      weight: "0",
    },
    {
      Description: "Client Survey Score",
      weight: "0",
    },
    {
      Description: "Total",
      weight: "0",
    },
  ];
  const TechnicalAssessmentColumns = [
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
      width: "90%",
    },
    {
      title: "Weight",
      dataIndex: "weight",
      key: "weight",
      width: "10%",
      className: "normal-column",
    },
  ];

  const IndividualForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [24, 24, 24],
        fields: [
          [
            {
              id: 1,
              label: "No of years with the Firm:",
              type: "text",
              name: "noofyears",
              Placeholder: "Enter",
            },
            {
              id: 2,
              label: "Years of Experience:",
              type: "text",
              name: "yearsofexperience",
              Placeholder: "Enter",
            },
          ],
          [
            {
              id: 3,
              label: "Qualifications Category:",
              type: "text",
              name: "1ualificationscategory",
              Placeholder: "Enter",
            },
            {
              id: 2,
              label: "Age:",
              type: "select",
              name: "age",
              Placeholder: "Select",
            },
          ],
        ],
      },
    ],
  };

  const IndividualDynamicAttributescolumns = [
    {
      title: "GAF / BDO EA Values",
      dataIndex: "gaf",
      key: "gaf",
      width: "10%",
      className: "gaf-column-header",
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
      width: "80%",
      className: "normal-column",
    },
    {
      title: "Weight",
      dataIndex: "weight",
      key: "weight",
      width: "18%",
      className: "normal-column",
    },
  ];

  const BasicForm1 = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [24, 24, 24],
        fields: [
          [
            {
              id: 1,
              label: "Individual- Wow Factor(10%):",
              type: "text",
              name: "wowfactor (Your Differentiator)",
              Placeholder: "Enter",
            },
          ],
          [
            {
              id: 2,
              label: "Self Overall Comment:",
              type: "textarea",
              name: "SelfOverallComment",
              Placeholder: "Enter",
            },
          ],
          //   [
          //     {
          //       id: 3,
          //       label: "Close",
          //       type: "button",
          //       position: "start",
          //       textColor: "white",
          //       event: "submit",
          //     },
          //   ],
        ],
      },
    ],
  };
  const IndividualDynamicAttributesData = [
    {
      gaf: "Integrity",
      Description: (
        <>
          Demonstrates hight emotional quotient and leadership traits.<br></br>{" "}
          Demonstrates knowledge of policies and practices well.<br></br>{" "}
          Experiences very little difficulty in acquiring/learning
          knowledge/information.<br></br> Keeps abreast of work related
          developments.<br></br> Demonstrates ability to apply
          technical/professional knowledge and skills to immediate work
          situation.<br></br> Low level of supervision and guidance necessary.
          <br></br> Ensures that the limits to authority are respected at all
          times.<br></br> Demonstrates and embodies the BDO values and culture
          through their interactions, efforts and behaviour.<br></br> Should
          have a lot of Social Capital and must adhere to ESG and other ethical
          behaviours
        </>
      ),
      Weight: "0",
    },
    {
      gaf: "Effective communication",
      Description:
        "Expresses facts and ideas in a clear and logical manner, without excessive guidance.",
      Weight: "0",
    },
    {
      gaf: "Responsibility",
      Description: (
        <>
          Constantly accepts responsibility in a competent manner for own areas
          of work and those of subordinates.<br></br> Can be relied upon to
          accept responsibility in respect of other employees in their absence
          when requested to do so.<br></br> Normal level of supervision and
          counselling required.<br></br> Works out own programmes/approaches to
          overcome problems and competently performs to expectations where
          general principles are not adequate to determine procedure or
          decisions to be taken
        </>
      ),
      Weight: "0",
    },
    {
      gaf: "Reliability",
      Description: (
        <>
          Seldom needs to enquire about progress of a task.<br></br> Shows
          commitment to work.<br></br> Will readily accept changes in work, work
          patterns or procedures, work location etc. in order to help achieve
          objectives.
        </>
      ),
      Weight: "0",
    },
    {
      gaf: "Teamwork",
      Description: (
        <>
          Extremely positive and inspiring personality.<br></br> Co-operates
          well with supervisors, colleagues and those supervised.<br></br> Is
          polite and respectful of others.<br></br> Demonstrates a sound and
          healthy attitude when interacting with others.<br></br> Acceptable and
          gets on well with colleagues.<br></br> Able to influence and
          communicate well as part of a team.<br></br> Works to achieve team
          objectives and coaches/ mentors reportees.<br></br> Requires
          negligible level of supervision and guidance.
        </>
      ),
      Weight: "0",
    },
  ];
  return (
    <>
      <Styleddiv>
        <div className="breadcrumb">
          <p
            className="current-appraisal"
            onClick={() => history.push("/performancemanagement")}
          >
            Current Appraisal
          </p>
          <RightOutlined className="right-icon" />
          <p>Editing Appraisal</p>
        </div>
        <div>
          <p className="appraisal-information">Appraisal Information</p>
        </div>
        <div>
          <GridBuilder
            formStructureJson={AppraisalFormData}
            initialValues={data}
          ></GridBuilder>
        </div>
        <div>
          <p className="settings-title">Settings</p>
        </div>
        <div>
          <GridBuilder
            formStructureJson={AcceptPerfContractForm}
            initialValues={data}
          ></GridBuilder>
        </div>
        <Row gutter={16} className="mt-3">
          <Col sm={24} md={12}>
            <h6>Assessment Model:</h6>
            <ReusableTable
              data={AcceptPerformData}
              columns={AcceptPerformDatacolumns}
            />
          </Col>

          <Col sm={24} md={12}>
            <h6>Technical Assessment:</h6>
            <ReusableTable
              data={tempdata2}
              columns={AcceptPerformDatacolumns}
            />
          </Col>
        </Row>
        <GridBuilder formStructureJson={BasicForm} />
        <h6>Technical Assessment – Chargeable Engagements Aggregate</h6>
        <ReusableTable data={tempdata3} columns={TechnicalAssessmentColumns} />
        <h6>Technical Assessment – Key Responsibilities</h6>
        <ButtonKeySelect
          className="w-100 px-0 mx-0"
          // onClick={handleShowComponent}
        >
          Select Key Responsibilities
        </ButtonKeySelect>
        <u>
          <h6>Individual- Static Attributes (40%)</h6>
        </u>
        <GridBuilder formStructureJson={IndividualForm} />
        <h6>Individual- Dynamic Attributes (50%)</h6>
        <StyledBox>
          <ReusableTable
            data={IndividualDynamicAttributesData}
            columns={IndividualDynamicAttributescolumns}
          />
        </StyledBox>

        <GridBuilder formStructureJson={BasicForm1} />
        <br />
        <br />
        <br />
        <br />
        <div className="cancel-save-changes">
          <Button
            className="cancel-button"
            onClick={() => history.push("/performancemanagement")}
          >
            Cancel
          </Button>
          <Button className="save-changes-button" onClick={showConfirmModal}>
            Save Changes
          </Button>
        </div>
      </Styleddiv>
      <StyledModal width={500} height={260} open={isConfirmModal} footer={null}>
        <p className="confirm-paragraph">
          On editing, would you like to reopen this appraisal for employees who
          have already completed it, or make the changes available only for
          future participants?
        </p>
        <Radio.Group
          onChange={(e) => setSelectedOption(e.target.value)}
          value={selectedOption}
        >
          <Radio value="reopen" className="radio-text">
            Reopen the Appraisal
          </Radio>
          <br />
          <br />
          <Radio value="future" className="radio-text">
            Make the Changes Available only for Future Participants
          </Radio>
        </Radio.Group>
        <div>
          <Button className="cancel-modal-button">Cancel</Button>
          <Button className="save-changes-button">Save Changes</Button>
        </div>
      </StyledModal>
    </>
  );
};

export default EditingAppraisal;

const StyledModal = styled(Modal)`
  .confirm-paragraph {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .radio-text {
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 16px;
  }
  .ant-radio-checked .ant-radio-inner {
    border-color: #00da88 !important;
    background-color: #00da88 !important;
  }
  .ant-radio-checked .ant-radio-inner::after {
    background-color: white !important;
    border-color: white !important;
  }
  .ant-radio:hover .ant-radio-inner {
    border-color: #00da88 !important;
  }
  .cancel-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
  }
  .save-changes-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #c2fae5;
    font-weight: 400;
    font-size: 16px;
    color: #1f243b;
    border: #c2fae5;
  }
`;
